/**
 * @namespace PjaxMini
 * @aka SWRNEU.PjaxMini
 */
SWRNEU.PjaxMini = (function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'pjaxMini';
  var DATA_KEY = 'swr.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: 'button[data-spy="pjax"],a.paginationNavi[data-target^="#paginatedBlock"]'
  };

  /*
   TODO: private helpers go here.
   */

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  var PjaxMini = function () {

    function PjaxMini(element) {
      var self = this;

      // protected
      self.element = element;
      self.$element = $(self.element);

      //Da kein PJAX verwendet wird, müssen ein paar Funktionalitäten nachgeahmt werden
      switch(self.element.tagName) {
        case "BUTTON": self.handleButton();break;
        case "A": self.handleA();break;
        default: console.log("Kein Handler für", self.element.tagName, "gefunden!");
      }
    }

    PjaxMini.prototype.handleButton = function handleButton() {
      var self = this;

      self.ref = self.$element.data('src');

      if(!self.ref){
        return;
      }

      /******
       * Aufgrund der nicht funktionierenden Sortier-Buttons auf
       * Suchergebnisseiten, wird hier die Funktionalität von
       * PJAX nachgeahmt. Die URL, die im data-src-Attribut versteckt
       * ist, wird als neue URL verwendet.
       */
      self.$element.on('click',function (){
        console.log(self.$element, "Sortier-Button geklickt", self.ref);
        window.location = self.ref;
      });
    };

    PjaxMini.prototype.handleA = function handleA() {
      var self = this;

      self.$element.on('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var url = new URL(self.element.href);
        url.searchParams.set("data-target", self.$element.data('target').replace("#",""));

        if(self.$element.data('scrollto')) {
          url.searchParams.set("data-scrollto","true");
        }

        console.log(self.$element, "Paginierungslink geklickt", url.toString());
        window.location = url.toString();
      });
    };

    // public
    PjaxMini.prototype.dispose = function dispose() {
      this.$element.off(EVENT_KEY);

      $('.modal').remove();

      this.$element = null;
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // static
    PjaxMini._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new PjaxMini(this);
          $(this).data(DATA_KEY, data);
        }
      });
    };

    return PjaxMini;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    PjaxMini._jQueryInterface.call($element, $element.data());
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      PjaxMini._jQueryInterface.call($element, $element.data());
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = PjaxMini._jQueryInterface;
  $.fn[NAME].Constructor = PjaxMini;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return PjaxMini._jQueryInterface;
  };

  return PjaxMini;

})(window.jQuery);
